import { stockAlertsSlice } from './slice'

// Get All
export const { setStockAlertLoading } = stockAlertsSlice.actions
export const { setStockAlertList } = stockAlertsSlice.actions
export const { resetStockAlertList } = stockAlertsSlice.actions
/* Stock Alert Delete Reducers */
export const { setStockAlertDeleteLoading } = stockAlertsSlice.actions
export const { setStockAlertDeleteSuccess } = stockAlertsSlice.actions
export const { resetStockAlertDelete } = stockAlertsSlice.actions
/* Stock Alert Create Reducers */
export const { setStockAlertCreateLoading } = stockAlertsSlice.actions
export const { setStockAlertCreateSuccess } = stockAlertsSlice.actions
export const { resetStockAlertCreate } = stockAlertsSlice.actions
